const LIMIT_INCLUDED = 2;

export { LIMIT_INCLUDED };
